import React from 'react';
import PropTypes from 'prop-types';
import LicensePartnerMapper from 'components/license-partners-mapper/LicensePartnerMapper';
import Box from '@mui/material/Box';
import Button from 'core/buttons/Button';
import { useLocation, useNavigate } from 'react-router-dom';
import { buildRoute } from 'routes';
import Auth from 'utils/Auth';

export default function LicensePartnerMapperTab({ partnerId }) {
  const navigate = useNavigate();
  const { pathname } = useLocation();

  return (
    <>
      <Box display="flex" justifyContent="flex-end" sx={{ mb: 2 }}>
        <Button
          onClick={() => {
            navigate(
              buildRoute(
                'license-partner-mapper.create',
                Auth.isSuperAdmin() ? { partner_id: partnerId } : {},
              ),
              {
                state: {
                  partnerId,
                  fromPath: pathname,
                },
              },
            );
          }}
        >
          Add License Partner Mapper
        </Button>
      </Box>
      <LicensePartnerMapper partnerId={partnerId} />
    </>
  );
}

LicensePartnerMapperTab.propTypes = {
  partnerId: PropTypes.string.isRequired,
};
